// import color from "../../../constants/color";

import color from "../../../../constants/color"

const styles = {

  tableHead: {
    color: "#878787",
    fontWeight: "400",
    whiteSpace: "nowrap"
  },
  checkboxGrid: {
    mt: 1
  },
  leaveHeading: {
    fontWeight: 600,
    fontSize: "18px",
  },
  gridSection: {
    justifyContent: "space-between",
    alignItems: "center"
  },
  gridSections: {
    alignItems: "center"
  },


  tabledata: {
    borderBottom: 0,
    whiteSpace: "nowrap"
  },
  tableAvtardata: {
    borderBottom: 0,
    display: "flex",
    alignItems: "center",
  },
  profileAvtar: {
    mr: 1,
    borderRadius: "50%",

  },

  tableActiondata: {
    borderBottom: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "start",

  },
  dropdown: {
    "& .css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input": {
      padding: "8.5px 14px",

    },
    width: "100%",
    fontSize: "14px",
    fontWeight: "400"
  },
  dropdownMenu: {
    fontSize: "14px",
    fontWeight: "400"
  },
  modalInput: {
    display: "flex",    // backgroundColor:color.lightGray,
    borderRadius: "30px",
    // width:{ xs: "25em", md: "35em" },
    justifyContent: "center",// Center align on smaller screens
    my: "10px",
    height: "2.5em",
    "& .css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input": {
      padding: "8.5px 14px"
    },
    "& .MuiOutlinedInput-root": {
      padding: "0"
    }
  },
  inputSpace: {
    "& .MuiOutlinedInput-root": {
      padding: "0px 14px"
    }

  },
  reason: {
    borderRadius: "8px",

    width: "100%",
    // mt: 1,
    height: "4.5em",
  },
  name: {
    color: color.text,
    fontSize: "14px",
    fontWeight: "400",
    whiteSpace: "nowrap"
  },
  mail: {
    color: color.lightText,
    fontSize: "14px",
    fontWeight: "400",
    whiteSpace: "nowrap"
  },
  label: {
    fontSize: "12px",
    fontWeight: "500",
    color: color.text
  },
  labels: {
    fontSize: "12px",
    fontWeight: "500",
    color: color.text,
    my: "10px"
  },


  hoursInput: {
    width: "100%",
    borderRadius: "8px",
    height: "2.5em",
    "& .css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input": {
      padding: "8.5px 14px"
    },
  },
  iconstyle: {
    width: "2.8em",
    backgroundColor: "#28AA4A33",
    borderRadius: "8px",
    height: "2.5em",
    padding: "0.6rem",
    marginTop: "2pc",
    marginLeft: "23px !important"
  },
  deleteIconstyle: {
    width: "2.8em",
    backgroundColor: "#FF000033",
    borderRadius: "8px",
    height: "2.5em",
    padding: "0.6rem",
    marginTop: "2pc",
    marginLeft: "33px !important"
  },
  button: {
    borderRadius: 50,
    textTransform: "none",
    backgroundColor: color.primary,
    ml: { xs: 0, md: "10px" },
    fontSize: "12px",
    fontWeight: "500"
  },
  dateInput: {
    width: "100%",
    "& .MuiInputBase-input": {
      padding: "8.5px 14px"
    }
  },
  projectContainer: {
    display: { xs: "block", md: "flex" },
    alignItems: "center",
    gap: "20px",
    my: 1
  },
  projectContainers: {
    alignItems: "center",
    gap: "20px",
    my: 1
  }

}
export default styles
